import React, { useState, useEffect } from 'react'
import { Menu, Tooltip } from 'antd'
import { NavLink } from 'react-router-dom'

import { findTreeNode } from '@/utils/util'

type Props = {
  routes: Routes
}

const { SubMenu, Item: MenuItem } = Menu

const Aside: React.FC<Props> = ({ routes }) => {
  const [openKeys, setOpenKeys] = useState<string[]>([])
  const [selectedKeys, setSelectedKeys] = useState<string[]>([])
  const path = location.hash.replace('#', '')

  useEffect(() => {
    const newOpenKeys = getOpenKeys(path)
    setSelectedKeys([path] as string[])
    setOpenKeys(newOpenKeys as string[])
  }, [path])

  const getRoute = (url: string) => {
    return findTreeNode(routes, 'path', url, 'routes')
  }

  const getOpenKeys = (path: string) => {
    const pathSnippets = path.split('/').filter(i => i)
    return pathSnippets
      .map((_, index) => {
        const url = `/${pathSnippets.slice(0, index + 1).join('/')}`
        const route = getRoute(url)
        if (route && route.routes?.length) {
          return route.path
        }
      })
      .filter(Boolean)
  }

  const renderMenu = (routes: Routes, level = 0) => {
    return routes.map(route => {
      const { routes } = route
      if (routes && routes.length) {
        return (
          <SubMenu
            key={route.path}
            title={
              <div>
                {route.icon && <route.icon />}
                <span>{route.name}</span>
              </div>
            }
          >
            {renderMenu(routes, ++level)}
          </SubMenu>
        )
      } else {
        if (route.hide === true) return null
        return route.name ? (
          <MenuItem key={route.path} style={{ margin: '10px 0' }}>
            {route.icon && (
              <span className="mr10">
                <route.icon />
              </span>
            )}
            {level >= 5 ? (
              <Tooltip title={route.name} placement="right">
                <NavLink to={route.path} activeClassName="menu-selected">
                  {route.name}
                </NavLink>
              </Tooltip>
            ) : (
              <NavLink to={route.path} activeClassName="menu-selected">
                {route.name}
              </NavLink>
            )}
          </MenuItem>
        ) : null
      }
    })
  }

  return (
    <div style={{ width: 210 }}>
      <Menu
        selectedKeys={selectedKeys}
        openKeys={openKeys}
        mode="inline"
        className="manage-aside"
        onOpenChange={keys => {
          setOpenKeys(keys)
        }}
      >
        {renderMenu(routes)}
      </Menu>
    </div>
  )
}

export default Aside
